<template>
  <div>
    <el-form :model="infoForm">
      <table width="966px" height="255px" cellspacing="0" class="fontStyle2">
        <tr>
          <td height="40" />
          <td>性别：</td>
          <el-select v-model="sex" placeholder="请选择" size="mini">
            <el-option
              v-for="(item,index) in options"
              value-key="item.value"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <td />
        </tr>
        <tr>
          <td height="40" />
          <td>国别：</td>
          <td>
            <el-select v-model="national" placeholder="请选择" size="mini">
              <el-option
                v-for="item in optionsnational"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </td>
          <td />
        </tr>
        <tr>
          <td height="40" />
          <td>职业：</td>
          <td>
            <el-select v-model="occupation" placeholder="请选择" size="mini">
              <el-option
                v-for="item in optionsoccupation"
                :key="item.id"
                :value="item.paramKey"
                :label="item.paramValue">
              </el-option>
            </el-select>
          </td>
          <td />
        </tr>
        <tr class="iteform">
          <td height="40" />
          <td>详细地址（请精确到门牌号）：</td>
          <div style="display: flex;">
            <el-form-item prop="personProv">
              <el-select v-model="personProv"  placeholder="省" :clearable="true" style="width:110px;"  size="mini" @change="getCityData">
                <el-option
                  v-for="(item) in provinceArray"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item prop="personCity">
              <el-select v-model="personCity" placeholder="市" :clearable="true"  size="mini" style="padding-left:5px;width:110px;" @change="getCountyData">
                <el-option
                  v-for="(item) in cityArray"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item prop="personCounties">
              <el-select v-model="personCounties" placeholder="区/县" :clearable="true"  size="mini" style="padding-left:5px;width:110px;" @change="changeCountyData">
                <el-option
                  v-for="(item) in countyArray"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item prop="address">
              <el-input v-model="addresslist" style="width:340px" placeholder="请输入详细地址(精确到门牌号)"  size="mini" />
            </el-form-item>
          </div>
          <td />
        </tr>
      </table>
      <el-button class="update" @click="informationUpdate">更新资料</el-button>
    </el-form>
  </div>
</template>

<script>
import { getPersonalInfo, otherInfoSearch, infoUpdate, queryBusinessDict, personCertificate } from '@/api/info'
import { setNull, getArea } from '@/api/common/common'
import Session from '@/utils/session'
import File from '@/utils/file'
import compress from '@/utils/compress'
import imgSize from '@/utils/imgSize'
import { getName } from '@/api/security/security'
export default {
  data() {
    return {
      circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      auditStatus: '0',
      customerType: Session.getItem('customerType'),
      dialogVisibleinfo: false,
      fileList2: [],
      // 性别
      options: [
        {
          value: '0',
          label: '女'
        },
        {
          value: '1',
          label: '男'
        }
      ],
      // 国籍
      optionsnational: [
        {
          value: '00',
          label: '中国'
        }
      ],
      // 职业
      optionsoccupation: [],
      // 省
      provinceArray: [],
      cityArray: [],
      countyArray: [],
      // 性别
      sex: null,
      // 国籍
      national: null,
      // 职业
      occupation: null,
      personZ: {
        hide: false,
        flagUrl: 'personFrontUrl'
      },
      personalInfoForm: {
        editFlag: 1,
        customerId: Session.getItem('customerId'),
        // 身份证
        idCard: null,
        // 身份证正面
        idCardUrlFront: null,
        // 身份证反面
        idCardUrlBack: null,
        // 绑定手机
        phoneMask: Session.getItem('phoneMask'),
        // 所在省
        personProv: null,
        // 所在省编号
        personProvNo: null,
        // 所在市
        personCity: null,
        // 所在市编号
        personCityNo: null,
        // 所在县区
        personCounties: null,
        // 所在县区编号
        personCountiesNo: null,
        // 地址
        address: null,
        // 是否跨境 0-非跨境 1-跨境
        crossBorderFlag: '0',
        // 币种
        ccy: 'CNY',
        // 证件类型1：身份证；2：其他
        corporationIdCardType: '1',
        // 操作人-手机号
        openUserId: Session.getItem('phone')
      },
      sourceData: {},
      addresslist: null,
      // 省 市 区
      personCity: null,
      personCounties: null,
      personProv: null,
      // 所在省编码
      personProvNo: null,
      // 所在市编码
      personCityNo: null,
      // 所在地区县编码
      personCountiesNo: null,
      infoForm: {
        customerId: Session.getItem('customerId'),
        // 客户名称
        customerName: null,
        // 客户编号
        customerCode: null,
        // 身份证
        idCard: null,
        // 绑定手机
        phone: null,
        phoneMask: null,
        // 收货地址
        defaultAddress: null,
        // 注册时间
        createTime: null,
        // 客户机构号
        orgNo: null,
        // 实名认证标志 （00-临时,01-弱实名,02-强实名）
        authFlag: null,
        // 是否已设置登录密码 true false
        password: null,
        // 是否已设置支付密码 true false
        tradePassword: null,
        // 是否已设置密码保护 true false
        securityQuestion: null,
        // 省 市 区
        personCity: null,
        personCounties: null,
        personProv: null,
        // 所在省编码
        personProvNo: null,
        // 所在市编码
        personCityNo: null,
        // 所在地区县编码
        personCountiesNo: null,
        // 详细地址
        address: null
      }
    }
  },
  watch: {
    $route() {
      if (this.$route.name === 'personalInfo') {
        this.getData()
      }
    }
  },
  created() {
    this.getData()
    this.getName()
    this.getArea()
    this.otherInfoSearch()
    this.queryOption()
  },
  methods: {
    // 个人客户其他信息查询
    otherInfoSearch() {
      const param = {
        customerId: this.infoForm.customerId,
        customerType: this.customerType
      }
      otherInfoSearch(param)
        .then(res => {
          // this.infoForm = Object.assign({}, res.data)
          this.addresslist = res.data.address
          this.personProv = res.data.personProv
          this.personCity = res.data.personCity
          this.personCounties = res.data.personCounties
          this.personCountiesNo = res.data.personCountiesNo
          this.personCityNo = res.data.personCityNo
          this.personProvNo = res.data.personProvNo
          this.sex = res.data.sex
          this.occupation = res.data.occupation
          this.national = res.data.national
        })
        .catch(error => {
          console.log(error) // 请求失败返回的数据
        })
    },
    // 上传身份证正面图片
    frontHandleUploadByPersonal(data, fileList, item) {
      const file = data.file
      imgSize(file).then(() => {
        compress(file, 100).then((res) => {
          const form = new FormData()
          form.set('file', res)
          File.upload(form)
            .then(response => {
              this.personalInfoForm.idCardUrlFront = response.data.code
            })
            .catch(error => {
              console.error(error)
            })
        })
      }).catch(() => {})
      // const form = new FormData()
      // form.append('file', file)
      // File.upload(form)
      //   .then(response => {
      //     console.log(response.data.code, 'idCardUrlFront')
      //     this.personalInfoForm.idCardUrlFront = response.data.code
      //   })
      //   .catch(error => {
      //     console.error(error)
      //   })
    },
    // 上传身份证反面图片
    backHandleUploadByPersonal(data, fileList, item) {
      const file = data.file
      imgSize(file).then(() => {
        compress(file, 100).then((res) => {
          const form = new FormData()
          form.set('file', res)
          File.upload(form)
            .then(response => {
              this.personalInfoForm.idCardUrlBack = response.data.code
            })
            .catch(error => {
              console.error(error)
            })
        })
      }).catch(() => {})
      // const form = new FormData()
      // form.append('file', file)
      // File.upload(form)
      //   .then(response => {
      //     console.log(response.data.code, 'idCardUrlBack')
      //     this.personalInfoForm.idCardUrlBack = response.data.code
      //   })
      //   .catch(error => {
      //     console.error(error)
      //   })
    },
    // 图片删除事件
    frontHandleRemoveByPersonal(file, fileList, item) {
      this.personalInfoForm.idCardUrlFront = null
    },
    // 图片删除事件
    backHandleRemoveByPersonal(file, fileList, item) {
      this.personalInfoForm.idCardUrlBack = null
    },
    // 图片上传change事件
    handleChangeByPersonal(file, fileList, item) {
      if (fileList.length >= 1) {
        item.hide = true
      }
      console.log(item.hide)
    },
    // 上传证件
    renewalCertificate() {
      this.dialogVisibleinfo = true
    },
    // 提交证件
    suBmitPersonal() {
      var sourceKey = Object.keys(this.sourceData)
      for (const item of sourceKey) {
        if (this.sourceData[item] !== this.personalInfoForm[item]) {
          this.personalInfoForm.editFlag = 1
          break
        } else {
          this.personalInfoForm.editFlag = 0
        }
      }
      const param = setNull(this.personalInfoForm)
      personCertificate(param).then(res => {
        this.$message.success(res.message)
        this.dialogVisibleinfo = false
      }).catch(error => {
        this.$message.error(error)
        this.dialogVisibleinfo = false
      })
    },
    queryOption() {
      const params = {
        itemCode: 'occupation'
      }
      queryBusinessDict(params).then(res => {
        this.optionsoccupation = res.data.list
      })
    },
    informationUpdate() {
      const param = {
        customerId: this.infoForm.customerId,
        customerType: this.customerType,
        sex: this.sex,
        occupation: this.occupation,
        national: this.national,
        personProv: this.personProv,
        personCity: this.personCity,
        personCounties: this.personCounties,
        address: this.addresslist,
        personProvNo: this.personProvNo,
        personCityNo: this.personCityNo,
        personCountiesNo: this.personCountiesNo
      }
      if (this.sex && this.occupation && this.national && this.addresslist && this.personProv && this.personCity && this.personCounties) {
        infoUpdate(param).then(res => {
          this.$message.success(res.message)
        })
      } else {
        this.$message.error('不能为空')
      }
    },
    // 获取省
    getArea() {
      const param = {}
      getArea(param)
        .then(res => {
          this.provinceArray = res.data.children
        })
        .catch(error => {
          // 捕获异常
          console.log(error)
        })
    },
    // 注册地址市
    getCityData(val) {
      this.cityArray = []
      this.countyArray = []
      this.personCity = null
      this.personCityNo = null
      this.personCounties = null
      this.personCountiesNo = null
      this.personProvNo = val
      for (const item of this.provinceArray) {
        if (item.id === val) {
          this.personProv = item.name
        }
      }
      if (val > 0) {
        const param = {
          id: val
        }
        return new Promise((resolve, reject) => {
          getArea(param)
            .then(res => {
              this.cityArray = res.data.children
              resolve(this.cityArray)
            })
            .catch(error => {
              reject(error)
              console.log(error) // 捕获异常
            })
        })
      }
    },
    // 注册县
    getCountyData(val) {
      this.countyArray = []
      this.personCounties = null
      this.personCountiesNo = null
      this.personCityNo = val
      for (const item of this.cityArray) {
        if (item.id === val) {
          this.personCity = item.name
        }
      }
      if (val > 0) {
        const param = {
          id: val
        }
        return new Promise((resolve, reject) => {
          getArea(param)
            .then(res => {
              this.countyArray = res.data.children
              resolve(this.countyArray)
            })
            .catch(error => {
              console.log(error) // 捕获异常
              reject(error)
            })
        })
      }
    },
    // 注册区事件
    changeCountyData(val) {
      this.personCountiesNo = val
      for (const item of this.countyArray) {
        if (item.id === val) {
          this.personCounties = item.name
        }
      }
    },
    getName() {
      getName({ customerId: this.infoForm.customerId }).then(response => {
        const { auditStatus } = response.data
        this.auditStatus = auditStatus
      }).catch(error => {
        console.log(error)
      })
    },
    // 查询
    getData() {
      const param = {
        customerId: this.infoForm.customerId
      }
      getPersonalInfo(param)
        .then(res => {
          console.log(res)
          this.infoForm = Object.assign({}, res.data)
          console.log(this.infoForm)
        })
        .catch(error => {
          console.log(error) // 请求失败返回的数据
        })
    },
    // 实名认证
    personalAuth() {
      this.$router.push({
        name: 'personalAuth'
      })
    },
    // 修改手机号
    editPhone() {
      this.$router.push({
        name: 'editPhone'
      })
    },
    // 管理收货地址
    address() {
      this.$router.push({
        name: 'manageAddress',
        params: {
          orgId: this.infoForm.orgNo
        }
      })
    },
    // 修改登陆密码
    editPassword() {
      this.$router.push({
        name: 'editPassword'
      })
    },
    // 修改登陆密码
    editLoginPassword() {
      this.$router.push({
        name: 'editLoginPassword'
      })
    },
    // 修改密保
    editEncrypted() {
      this.$router.push({
        name: 'editEncrypted'
      })
    },
    // 设置密保
    setEncrypted() {
      this.$router.push({
        name: 'setEncrypted'
      })
    },
    // 设置支付密码
    setPassword() {
      this.$router.push({
        name: 'setPassword'
      })
    },
    // 设置登录密码
    setLoginPassword() {
      this.$router.push({
        name: 'setLoginPassword'
      })
    },
    // 找回支付密码
    findPay() {
      this.$router.push({
        name: 'findPay'
      })
    }
  }
}
</script>

<style scoped>
    .nameStyle {
        width: 48px;
        height: 21px;
        font-size: 16px;
        color: #5E5E5E;
        line-height: 21px;
    }

    .fontStyle {
        width: 42px;
        height: 19px;
        margin-left: 12px;
        font-size: 14px;
        color: #DE201D;
        line-height: 19px;
    }

    .buttonStyle {
        font-size: 12px;
        color: #498AEA;
        margin-right: 5px;
    }

    .fontStyle2 {
        font-size: 12px;
        color: #5E5E5E;
        line-height: 16px;
    }

    .table {
        margin-left: 30px;
        border: solid #E7E8EC;
        border-width: 1px 0 0 1px;
    }

    .td0 {
        border: solid #E7E8EC;
        border-width: 1px 0 0 0;
    }

    .td1 {
        border: solid #E7E8EC;
        border-width: 0 1px 1px 0;
        padding: 0 0 0 15px;
        font-size: 12px;
        color: #333333;
        background-position: center;
        text-align: center;
        background-color: #FAFAFB;
    }

    .td2 {
        border: solid #E7E8EC;
        border-width: 0 0 1px 0;
        padding: 0 0 0 15px;
        color: #666666;
        font-size: 12px;
    }

    .td3 {
        border: solid #E7E8EC;
        border-width: 0 1px 1px 0;
        padding: 0 0 0 15px;
    }
    .update{
      display: flex;
      margin: 20px auto;
      background-color: #498AEA;
      border: 1px solid #498AEA;
      color: #fff;
    }
    .iteform .el-form-item{
      margin-bottom: 0px;
    }
    .a{
      color: #498AEA;
      text-decoration:underline;
    }
</style>
